export enum Area {
    Arctic,
    Desert,
    Forest,
    Island,
    Swamp,
    Candy,
    Moon,
    WukArea,
}
